import React from "react";
import logoFooter from "../src/Assests/Rise Images/Rize.png";
import google from "../src/Assests/Rise Images/google.png";
import appStorw from "../src/Assests/Rise Images/app.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <br />
      <br />

      <div className="container ps-5 footer d-flex justify-content-start">
        <div>
          <img style={{ width: "40%" }} src={logoFooter} alt="logo" />
          <br />

          <h2 className="unset-margin" style={{ fontWeight: "bolder" }}>
            Download App
          </h2>
          <div className="downloads-icons d-flex">
            <img
              onClick={() =>
                window.open(
                  "https://apps.apple.com/eg/app/rize/id6479608386",
                  "_blank"
                )
              }
              className="download-btn"
              src={appStorw}
              width={200}
              alt="app store"
            />
            <img
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.enovate.rize&pli=1",
                  "_blank"
                )
              }
              className="download-btn"
              src={google}
              width={200}
              alt="google"
            />
          </div>
        </div>
        <div className="d-flex about">
          <div>
            <br />
            <br />
            <h3 style={{ fontWeight: "bolder", color: "#014651" }}>About</h3>
            <br />
            <div style={{ lineHeight: 2 }}>
              A cobranded Prepaid Payment Card paired with a <br />{" "}
              user-friendly Mobile Application, tailor-made for the <br />{" "}
              dynamic youth residing within gated communities
            </div>
          </div>
          <div className="terms">
            <div className="col-12 col-md-6 w-100 legal d-flex flex-column ">
              <br />
              <br />

              <h3 style={{ fontWeight: "bolder", color: "#014651" }}>Legal</h3>
              <br />

              <Link to="/terms">Terms of Use</Link>
              <br />

              <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div
        className="strip container-fluid text-center pt-3 pb-3"
        style={{ background: "#014651", color: "white" }}
      >
        <div className="d-flex justify-content-between custom-padding">
          <div className="d-flex align-items-center">
            <div className="px-3">Powered By eNovate</div>
            <div>
              <a
                href="https://www.instagram.com/enovate_efih/?igsh=MXhhenB1cDl1eXZjcg%3D%3D#"
                className="social-link iconBox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="whiteIcon fab fa-instagram"></i>
              </a>
              <a
                href="https://eg.linkedin.com/company/enovatepaymentenabler"
                className="social-link iconBox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="whiteIcon fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://www.facebook.com/enovatedigitalpaymentenabler/"
                className="social-link iconBox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="whiteIcon fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
          <div className="copyRight">
            Copyright {new Date().getFullYear()}. All rights reserved.
          </div>
        </div>
      </div>
    </>
  );
}
